import AuthenticatedTemplate from "../../components/AuthenticatedTemplate";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ICONS, LOGOS } from "../../utils/assets";

import { Footer } from "../../components/Footer";
import Button from "../../components/form/Button";
import ProgressBar from "../../components/ProgressBar";
import Alert from "../../components/Alert";
import { useOrganisationsStore } from "../../stores/organisations-store";

export const Dashboard05OrganisationsDetails = () => {
  const navigate = useNavigate();
  const {
    selectedOrganisations,
    removeOrganisation,
    updateOrganisationAccountID,
  } = useOrganisationsStore();
  const [errors, setErrors] = useState({});

  const filteredOrganisations = useMemo(() => {
    return selectedOrganisations.filter(
      (item) => item.Organisation_Account_Label
    );
  }, [selectedOrganisations]);

  const clearInputError = (name, value) => {
    const errorKey = name;

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[errorKey];
      }
      return newErrors;
    });
  };

  /**
   * Function to add the input to the Organisation account ID
   */
  const handleInput = (orgId, value) => {
    updateOrganisationAccountID(orgId, value);

    clearInputError(orgId, value);
  };

  const validateFields = () => {
    const newErrors = {};

    filteredOrganisations.forEach((item) => {
      const id = item.Organisation_ID;
      const label = item.Organisation_Account_Label;
      const value = item.Organisation_Account_ID;

      if (!value) {
        newErrors[id] = `${label} can't be blank.`;
      }
    });

    if (!selectedOrganisations.length)
      newErrors["selectedOrganisations"] =
        "Please select at least one organisation.";

    if (Object.keys(newErrors).length === 0) return true;

    setErrors(newErrors);

    return false;
  };

  const handleContinue = () => {
    const isValid = validateFields();

    if (isValid) navigate("/dashboard-review-details");
  };

  return (
    <>
      <AuthenticatedTemplate>
        <section className="step__container">
          <div className="step__content">
            <div className="organisation-details">
              <div className="step__header">
                <img
                  className="logo"
                  src={LOGOS.QUICKMOVE_FLOW}
                  alt="Quickmove logo"
                />
                <div>
                  <h1 className="text-md text-md--variant">
                    Organisation Details
                  </h1>
                  <p className="paragraph-md">
                    Each organisation requires unique information to process
                    your update. Please fill in the required details for each
                    provider
                  </p>
                </div>
              </div>

              <ProgressBar percentage="56" />

              <div className="organisation-details__content">
                <Alert
                  message="Complete your application by entering the recommended
                    details to continue."
                  closable
                />

                {selectedOrganisations
                  ? filteredOrganisations.map((item, index) => {
                      return (
                        <div
                          className="organisation-category"
                          key={item.Organisation_ID}
                        >
                          <div className="organisation-category__header">
                            <div className="organisation-category__info">
                              <div className="logo-box">
                                <img
                                  className="logo-box__image"
                                  src={item.Organisation_Logo_Path}
                                  alt={"Organisation logo"}
                                />
                              </div>
                              <p className="paragraph-md semibold paragraph-md--dark">
                                {item.Organisation_Name}
                              </p>
                            </div>
                            <button
                              className="button button--compact button--danger"
                              onClick={() =>
                                removeOrganisation(item.Organisation_ID)
                              }
                            >
                              Delete
                            </button>
                          </div>
                          <div className="input-field">
                            <label>{item.Organisation_Account_Label} *</label>
                            <input
                              type="text"
                              maxLength="20"
                              className="organisation-details__input"
                              placeholder={
                                item.Organisation_Account_ID
                                  ? item.Organisation_Account_ID
                                  : "Enter your " +
                                    item.Organisation_Account_Label.toLowerCase()
                              }
                              id={item.Organisation_ID}
                              value={item.Organisation_Account_ID || ""}
                              onChange={(e) =>
                                handleInput(
                                  item.Organisation_ID,
                                  e.target.value
                                )
                              }
                            ></input>
                            {errors[item.Organisation_ID] && (
                              <p className="paragraph-md text-danger">
                                {errors[item.Organisation_ID]}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })
                  : null}

                {errors["selectedOrganisations"] && (
                  <p className="paragraph-md text-danger">
                    {errors["selectedOrganisations"]}
                  </p>
                )}
              </div>

              <div className="action-buttons">
                <Link to="/dashboard-organisations">
                  <Button variant="outlined">Back</Button>
                </Link>
                <Button
                  variant="primary"
                  icon={ICONS.CARET_ICON}
                  iconAlt="Caret icon"
                  onClick={() => handleContinue()}
                >
                  Continue
                </Button>
              </div>
              <Footer />
            </div>
          </div>
        </section>
      </AuthenticatedTemplate>
    </>
  );
};
